import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

//TYPES
import {CreateEmployeeNotes} from "../Types/Employee/EmployeeNotes";

export const EMPLOYEE_NOTES_QUERY_KEY = ["employee-notes"];
export const VIEW_EMPNOTES_QUERY_KEY = ["view-employee-notes"];

export const employeeNotesService = {
  createNotes: async (payload: CreateEmployeeNotes) => {
    const response = await api.post(`api/employee-notes`, payload);
    return response.data;
  },
  getByApplication: async (application_no: string) => {
    const response = await api.get(
      `api/applicant-notes/${application_no}/appl-no`,
    );
    return response.data;
  },
  viewByApplication: async (application_no: string) => {
    const response = await api.get(
      `api/view-applicant-notes/${application_no}/appl-no`,
    );
    return response.data.data;
  },
  ViewEmployeeNotesByEmpno: async (emp_no: string) => {
      const response = await api.get(
        `api/view-employee-notes/${emp_no}`,
      );
      return response.data.data;
    },
  toggleStatus: async (id: number) =>
    requestWithRefresh(() =>
      api
        .patch(`api/employee-notes/${id}/toggle-status`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
